<template>
  <div class="marketing-automation-form-panel-whatsapp">
    <app-form @submit="setStep">
      <marketing-automation-form-panel-section :title="$t('message.automation.message.setWhatsapp')">
        <app-select class="marketing-automation-form-panel-whatsapp-section-select"
                    v-model="form.whatsId"
                    :data-items="options"
                    :infiniteId="infiniteId"
                    :data-title="$t('message.automation.message.setWhatsapp')"
                    data-menu-width="200px"
                    titleMaxWidth="250px"
                    infinite-loading
                    small
                    @search="searchOptions"
                    @load="loadOptions" />
      </marketing-automation-form-panel-section>

      <marketing-automation-form-panel-section>
        <button class="marketing-automation-form-panel-whatsapp-section-action btn btn-round btn-primary"
                type="submit">{{ actionText }}</button>
      </marketing-automation-form-panel-section>
    </app-form>
  </div>
</template>

<script>
import AppSelect from "@components/Select";
import AppForm from "@components/form/Form.vue";
import MarketingAutomationFormPanelSection from "@components/modules/marketing/automation/form/steps/panel/section/MarketingAutomationFormPanelSection.vue";

export default {
  components: {
    AppForm,
    MarketingAutomationFormPanelSection,
    AppSelect,
  },

  props: {
    step: {
      type: Object,
    },
    automationId: {
      type: String,
    },
  },

  data() {
    return {
      options: [],
      page: 0,
      filter: undefined,
      infiniteId: +new Date(),
      form: {
        whatsId: undefined,
      },
    };
  },

  created() {
    if (this.step) {
      this.setInitialData();
    }
  },

  computed: {
    actionText() {
      return this.step
        ? this.$t("message.generics.message.save")
        : this.$t("message.generics.message.add");
    },
  },

  methods: {
    async setInitialData() {
      await this.loadOptions();

      this.form.whatsId = this.step.properties.messageId;
    },
    setStep() {
      if (this.step && this.step.id) {
        this.editStep();
      } else {
        this.addStep();
      }
    },
    async addStep() {
      const steps = await this.$api.marketing.automation.flow.addStep({
        automationId: this.automationId,
        stepType: "CHANNEL",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          channelType: "WHATSAPP",
          messageId: this.form.whatsId,
        }),
      });

      this.$emit("submit", steps);
    },
    async editStep() {
      const steps = await this.$api.marketing.automation.flow.editStep({
        stepId: this.step.id,
        automationId: this.automationId,
        stepType: "CHANNEL",
        previousStepId: this.step.previousStepId,
        properties: JSON.stringify({
          channelType: "WHATSAPP",
          messageId: this.form.whatsId,
        }),
      });

      this.$emit("submit", steps);
    },
    searchOptions(text) {
      this.filter = text;
      this.reload();
    },
    reload() {
      this.page = 0;
      this.options = [];
      this.infiniteId++;
    },
    async loadOptions($state) {
      const list = await this.$api.marketing.whatsapp.message.list({
        page: this.page,
        filter: this.filter,
        isAutomation: true,
      });

      const formatedOptionsList = list.map((whatsapp) => {
        return {
          id: whatsapp.id,
          label: whatsapp.title,
        };
      });

      this.options.push(...formatedOptionsList);

      this.page += 1;

      if (list.length) {
        if ($state) {
          $state.loaded();
        }
      } else {
        if ($state) {
          $state.complete();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-form-panel-whatsapp {
  .marketing-automation-form-panel-whatsapp-section-select {
    margin: 0 auto;
  }

  .marketing-automation-form-panel-whatsapp-section-action {
    margin: 0 auto;
    display: block;
  }
}
</style>
